import React from "react"
import { Grid } from "@chakra-ui/react"

export interface ProductGridContainerProps extends React.PropsWithChildren {
  colsDesktop?: number
  colsMobile?: number
}

const ProductGridContainer = ({ colsDesktop = 4, colsMobile = 2, children }: ProductGridContainerProps) => (
  <Grid
    justifyContent="center"
    columnGap={2}
    rowGap={3}
    templateColumns={[`repeat(${colsMobile}, 1fr)`, `repeat(${colsDesktop}, 1fr)`]}
  >
    {children}
  </Grid>
)

export default ProductGridContainer
